/* src/app/home/home-screen.component.scss */
.home-container {
  display: flex;
}
.home-page {
  background-image: url("./media/marsh_background_image_2-WIPYCFKV.png");
  background-color: rgb(13, 60, 83);
  background-blend-mode: hard-light;
  width: 100vw;
  height: calc(100vh - 135px - 97px);
  background-size: cover;
  background-repeat: no-repeat;
  color: white;
  padding-top: 0;
  display: flex;
}
.disclaimer {
  margin: 0;
  padding: 30px 60% 14% 50px;
}
@media (max-width: 1280px) {
  .disclaimer {
    padding: 30px 60% 14% 30px;
  }
}
@media (max-width: 1080px) {
  .disclaimer {
    padding: 30px 60% 14% 15px;
  }
}
button {
  color: #fff;
  border-color: #fff;
  background-color: rgba(255, 255, 255, 0.1882352941);
  margin-top: 30px;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
button:hover {
  background-color: rgba(255, 255, 255, 0.3137254902);
}
button:active {
  transform: scale(0.95);
}
h2 {
  color: #ceecff;
  font-size: 35px;
  margin-bottom: 30px;
  font-family: "Marsh Serif", serif;
}
p {
  color: #dadada;
  font-size: 12pt;
}
@media (max-width: 2560px) {
  p {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  p {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  p {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  p {
    font-size: 8pt;
  }
}
/*# sourceMappingURL=home-screen.component-EYRFSBH3.css.map */
